<div class="stations-page">
  <!-- Toolbar -->
  <div class="toolbar">
    <div class="search-box">
      <i class="bx bx-search"></i>
      <input
        type="text"
        placeholder="Search Stations..."
        [value]="searchTerm"
        (input)="onSearch($event)"
      />
    </div>

    <div class="right-controls">
      <div class="fnf-segmented fnf-segmented--compact" role="tablist">
        <button
          type="button"
          class="fnf-segment"
          [class.fnf-segment--active]="viewMode === 'list'"
          (click)="setViewMode('list')"
        >
          <i class="bx bx-list-ul" aria-hidden="true"></i> List
        </button>
        <button
          type="button"
          class="fnf-segment"
          [class.fnf-segment--active]="viewMode === 'grid'"
          (click)="setViewMode('grid')"
        >
          <i class="bx bx-grid-alt" aria-hidden="true"></i> Grid
        </button>
      </div>

      <button type="button" class="new-btn" (click)="addNewStation()">
        <i class="bx bx-plus"></i>
        New Station
      </button>
    </div>
  </div>

  @if (displayLoading) {
    <div
      class="d-flex flex-column align-items-center justify-content-center common-loading-container"
    >
      <div class="w-25 text-center">
        <img class="common-loading" src="assets/menu_loading.gif" alt="common loading" />
        <p class="common-loading-text">Loading stations, please wait...</p>
      </div>
    </div>
  } @else if (filteredStations.length > 0) {
    @if (viewMode === 'grid') {
      <!-- Card grid -->
      <div class="station-grid">
        @for (station of filteredStations; track station.station_id) {
          <div class="station-card">
            <div class="station-card-header">
              <span class="station-name">{{ station.station_name | titlecase }}</span>
              <div class="card-actions">
                <button
                  type="button"
                  class="icon-btn edit"
                  title="Edit Station"
                  (click)="addNewStation(station)"
                >
                  <i class="bx bx-edit-alt"></i>
                </button>
                <button
                  type="button"
                  class="icon-btn delete"
                  (click)="deleteStationConfirm(station)"
                  [class.disabled-delete]="station.is_default && station.station_type == 'kitchen'"
                  [title]="
                    station.is_default && station.station_type == 'kitchen'
                      ? 'Default kitchen station cannot be deleted'
                      : 'Delete Station'
                  "
                >
                  <i class="bx bx-trash"></i>
                </button>
              </div>
            </div>

            <div class="meta-group">
              <div class="info-row">
                <span class="info-label">Type</span>
                <span class="type-pill" [class]="'type-pill tone-' + station.station_type">
                  {{ typeLabel(station.station_type) }}
                </span>
              </div>
              <div class="info-row">
                <span class="info-label">Default Station</span>
                @if (station.is_default) {
                  <span class="state-pill yes">&#10003; Yes</span>
                } @else {
                  <span class="state-pill no">No</span>
                }
              </div>
              <div class="info-row">
                <span class="info-label">Date Added</span>
                <span class="info-value">{{ station.added_at | date: 'MMM d, y' }}</span>
              </div>
            </div>
          </div>
        }
      </div>
    } @else {
      <!-- List view -->
      <div class="list-card">
        <div class="list-head list-row">
          <span class="col-name">Station</span>
          <span class="col-type">Type</span>
          <span class="col-default">Default</span>
          <span class="col-added">Added</span>
          <span class="col-actions">Actions</span>
        </div>

        @for (station of filteredStations; track station.station_id) {
          <div class="list-row">
            <div class="col-name name-cell">
              <span class="station-avatar sm" [class]="'tone-' + station.station_type">
                {{ initials(station.station_name) }}
              </span>
              <span class="station-name">{{ station.station_name | titlecase }}</span>
            </div>
            <span class="col-type">
              <span class="type-pill" [class]="'tone-' + station.station_type">
                {{ typeLabel(station.station_type) }}
              </span>
            </span>
            <span class="col-default">{{ station.is_default ? 'Yes' : 'No' }}</span>
            <span class="col-added">{{ station.added_at | date: 'MMM d, y' }}</span>
            <span class="col-actions row-actions">
              <i
                class="bx bx-edit-alt action-icon edit"
                title="Edit Station"
                (click)="addNewStation(station)"
              ></i>
              <i
                class="bx bx-trash action-icon delete"
                (click)="deleteStationConfirm(station)"
                [class.disabled-delete]="station.is_default && station.station_type == 'kitchen'"
                [title]="
                  station.is_default && station.station_type == 'kitchen'
                    ? 'Default kitchen station cannot be deleted'
                    : 'Delete Station'
                "
              ></i>
            </span>
          </div>
        }

        <div class="list-footer">
          <span>Showing {{ filteredStations.length }} stations</span>
        </div>
      </div>
    }
  } @else if (stations.length > 0) {
    <div
      class="d-flex flex-column align-items-center justify-content-center common-empty-container"
    >
      <img src="assets/not-found.png" alt="No matches" class="common-empty-img mb-3" />
      <p class="common-empty-header">No Matching Stations</p>
      <p class="common-empty-sub-text">Try a different search term.</p>
    </div>
  } @else {
    <div
      class="d-flex flex-column align-items-center justify-content-center common-empty-container"
    >
      <img src="assets/not-found.png" alt="No Stations" class="common-empty-img mb-3" />
      <p class="common-empty-header">No Stations</p>
      <p class="common-empty-sub-text">Create stations to later assign printers.</p>
    </div>
  }
</div>
